"use client";

import { Mail, Phone, PhoneCall, MapPin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contact() {
  const containerRef = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="855" id="japanese-contact" className="bg-primary text-white py-24 sm:py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary-foreground/10 via-transparent to-transparent pointer-events-none" />
      
      <div ref={containerRef.ref} className={`mx-auto max-w-5xl px-6 lg:px-8 text-center transition-all duration-700 ease-out ${containerRef.isVisible ? "opacity-150 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <p className="font-default text-xs tracking-[0.255em] uppercase mb-4 text-secondary">ご相談・お問い合わせ</p>

        <h2 className="mb-6 font-serif font-default leading-[1.1] text-white" style={{
        fontSize: "clamp(2.1rem, 4vw, 3.25rem)"
      }}>
  ご相談内容を日本語でお聞かせください。
      </h2>

        <p className="font-default text-base sm:text-lg text-white/80 max-w-2xl mx-auto mb-12 leading-relaxed">フロリダ州・ニューヨーク州 におけるビジネス、不動産取引、プロベート、信託関連事項、およびAttorney’s Fee Hearingsについて、日本語で初期情報を整理し、担当弁護士への連絡をサポートします。</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Link to="tel:+19549259000" className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-secondary text-primary font-default font-medium px-8 py-4 rounded-lg shadow-lg hover:bg-secondary/90 transition-all duration-300">
            <PhoneCall className="w-5 h-5" />
            <span>(954) 925-9000</span>
          </Link>

          <Link to="/ContactUsPage" className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-transparent text-white border border-white/30 font-default font-medium px-8 py-4 rounded-lg hover:bg-white/10 transition-all duration-300">
            <span>お問い合わせフォームへ</span>
            <ArrowRight className="w-4 h-4 text-secondary" />
          </Link>
        </div>

        <div className="mt-16 pt-12 border-t border-white/15 grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
          <div className="flex items-start gap-4">
            <div className="p-3 bg-white/5 rounded-lg border border-white/10 text-secondary shrink-0">
              <PhoneCall className="w-6 h-6" strokeWidth={1.25} />
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-secondary mb-1 font-default">電話番号</p>
              <Link to="tel:+19549259000" className="font-serif text-lg text-white hover:text-secondary transition-colors">
                (954) 925-9000
              </Link>
              <p className="text-xs text-white/60 mt-1">月〜金 9:00am〜5:00pm</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="p-3 bg-white/5 rounded-lg border border-white/10 text-secondary shrink-0">
              <Mail className="w-6 h-6" strokeWidth={1.25} />
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-secondary mb-1 font-default">メール</p>
              <Link to="mailto:info@morrielevine.com" className="font-serif text-lg text-white hover:text-secondary transition-colors">
                info@morrielevine.com
              </Link>
              <p className="text-xs text-white/60 mt-1">内容を確認後、事務所からご連絡します</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="p-3 bg-white/5 rounded-lg border border-white/10 text-secondary shrink-0">
              <MapPin className="w-6 h-6" strokeWidth={1.25} />
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-secondary mb-1 font-default">所在地</p>
              <p className="font-serif text-sm text-white leading-snug">
                3300 North 29th Avenue, Suite 104, Hollywood, FL 33020
              </p>
              <p className="text-xs text-white/60 mt-1">フロリダ州ハリウッド</p>
            </div>
          </div>
        </div>

      </div>
    </section>;
}